import { t } from "@/i18n-js/instance";

import { IconButton } from "./IconButton";
import { useNavigationHistory } from "./useNavigationHistory";

export const BackForwardButtons = () => {
  const { canGoBack, canGoForward, goBack, goForward } = useNavigationHistory();

  const handleRefresh = () => {
    // Reload the current page/route
    window.location.reload();
  };

  return (
    <div className="flex items-center">
      <IconButton
        name="16-arrow-left"
        iconSize={16}
        iconClassName="!text-c-header"
        className="hover:!bg-c-header-hover focus-visible:!bg-c-header-hover !p-0 py-1"
        disabled={!canGoBack}
        onClick={goBack}
        ariaLabel={t("settings.navigation.back")}
        dataTestId="navigation-back-button"
      />
      <IconButton
        name="16-arrow-right"
        iconSize={16}
        iconClassName="!text-c-header"
        className="hover:!bg-c-header-hover focus-visible:!bg-c-header-hover !p-0 py-1"
        disabled={!canGoForward}
        onClick={goForward}
        ariaLabel={t("settings.navigation.forward")}
        dataTestId="navigation-forward-button"
      />
      <IconButton
        name="16-refresh"
        iconSize={16}
        iconClassName="!text-c-header"
        className="hover:!bg-c-header-hover focus-visible:!bg-c-header-hover !h-[0.8rem] !p-0 py-1"
        onClick={handleRefresh}
        ariaLabel={t("settings.navigation.refresh")}
        dataTestId="navigation-refresh-button"
      />
    </div>
  );
};
